import DeleteIcon from '@mui/icons-material/Delete';
import { Box, IconButton, Stack } from "@mui/material";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import AttachmentLink from "./attachment.link";
import attachmentService from './attachment.service';

export default function AttachmentList(props) {
	let [attachments, setAttachments] = useState(props.attachments);
	useEffect(() => {
		setAttachments(props.attachments);
	}, [props.attachments?.length]);

	attachments = _.sortBy(attachments, 'fileName');

	const onDelete = async (attachment) => {
		await attachmentService.delete(attachment.id);
		_.remove(attachments, { id: attachment.id });
		setAttachments([ ...attachments ]);
		props?.onDelete?.(attachment);
	};

	return (
		<Stack direction="column" spacing={0} alignItems="left">
			{attachments.length > 0 && attachments?.map((attachment, i) =>
				<Stack className="hover-toggle" key={i + attachment.id}>
					<AttachmentLink attachment={attachment} />
					<IconButton className="hover hover-toggle" onClick={() => onDelete(attachment)} sx={{p:0, mx:2}}>
						<DeleteIcon sx={{ fontSize: 16 }} className="hover-subtle" />
					</IconButton>
				</Stack>
			)}
		</Stack>
	);
}